import { handleApiError } from '@/lib/handleApiError';
import axiosInstance from '@/utils/axiosInstance';

export const uploadSalesFile = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/SmartProAPI/api/salesfile/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesFiles = async (
  page,
  size,
  search,
  sortField,
  sortDirection,
) => {
  try {
    const response = await axiosInstance.get(
      `/SmartProAPI/api/salesfile/get-sales-files?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortField}&sortDir=${sortDirection}`,
    );
    if (response.status === 204) {
      return ['No Data Found'];
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWhrehouseList = async () => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/salesfile/distinct-whse`,
    );
    return res.data;
  } catch (error) {
    handleApiError('error', error.response?.data, error?.response?.status);
    throw error;
  }
};
